/**
 * Date Formatting Utilities
 *
 * Shared date formatting functions for consistent display across the application.
 */

/**
 * Format a date string for display (short format)
 * @param {string|Date} dateString - Date to format
 * @returns {string} Formatted date string or 'N/A' if invalid
 */
export function formatDate(dateString) {
  if (!dateString) return 'N/A';
  return new Date(dateString).toLocaleString();
}

/**
 * Format a date string with full details
 * @param {string|Date} dateString - Date to format
 * @returns {string} Formatted date string with time or 'N/A' if invalid
 */
export function formatDateFull(dateString) {
  if (!dateString) return 'N/A';
  return new Date(dateString).toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  });
}

/**
 * Format a date string (date only, no time)
 * @param {string|Date} dateString - Date to format
 * @returns {string} Formatted date string or 'N/A' if invalid
 */
export function formatDateOnly(dateString) {
  if (!dateString) return 'N/A';
  return new Date(dateString).toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric'
  });
}
